/**
 * Flatten API / form errors into a string safe to render in MUI Alert / helperText.
 * Prevents React "Objects are not valid as a React child" and "[object Object]".
 *
 * @param {unknown} value
 * @param {string} [fallback="Something went wrong"]
 * @returns {string}
 */
export function formatDisplayError(
  value,
  fallback = "Something went wrong"
) {
  if (value == null || value === "") return fallback;

  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed || trimmed === "[object Object]") return fallback;
    return trimmed;
  }

  if (value instanceof Error) {
    return formatDisplayError(value.message, fallback);
  }

  if (Array.isArray(value)) {
    const parts = value
      .map((item) => formatDisplayError(item, ""))
      .filter(Boolean);
    return parts.length ? parts.join(". ") : fallback;
  }

  if (typeof value === "object") {
    const details = value.details
      ? formatDisplayError(value.details, "")
      : "";
    const head = formatDisplayError(
      value.error || value.message || value.detail || value.msg,
      ""
    );
    if (head && details) return `${head}: ${details}`;
    if (head) return head;
    if (details) return details;
  }

  return fallback;
}
